import ActionDropdown from "../../ActionDropdown";
import TableCheck from "../TableCheck";
import { cutString, dateFine } from "../../../util/Utilities";
import DateFormatter from "../../DateFormatter";
import clsx from "clsx";
import UserHavePermission from "../../../util/UserHavePermission";
import SystemInfo from "../../../util/SystemInfo";

const PowerBiViewsColumns = [
    {
        Label: TableCheck,
        Component: TableCheck
    },
    {
        Label: () => 'id',
        accessor: 'id',
        sortField: 'id'
    },
    {
        Label: () => 'Usuario',
        sortField: 'userName',
        Component: ({ value }) => value?.user?.name || '--'
    },
    {
        Label: () => 'Power Bi',
        sortField: 'powerbiTitle',
        Component: ({ value }) => value?.powerbi?.title || '--'
    },
    {
        Label: () => 'Última Visita',
        sortField: 'created_at',
        Component: ({ value }) => value?.createdAt || '--'
    },
    {
        Label: () => 'Acciones',
        Component: (props) => <ActionDropdown
            {...props}
            withOutUpdate
            showDelete={UserHavePermission(`${SystemInfo?.systemCode}-delete-${props?.entity}`)}
        />
    }
];

export default PowerBiViewsColumns;